/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_DownloadInputs */

const en_invoice_download = /** @type {(inputs: Invoice_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

const pl_invoice_download = /** @type {(inputs: Invoice_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktura`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Invoice_DownloadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_download = /** @type {((inputs?: Invoice_DownloadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_DownloadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_download(inputs)
	return en_invoice_download(inputs)
});